import { Box, Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../../../theme";

interface TabBarProps {
  tabs: string[];
  activeIndex: number;
  onChange: (index: number) => void;
}

export default function TabBar({ tabs, activeIndex, onChange }: TabBarProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Stack
      direction="row"
      sx={{
        mb: 3,
        width: "100%",
        overflowX: "auto",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {tabs.map((tab, index) => (
        <Box
          key={index}
          onClick={() => onChange(index)}
          sx={{
            flex: 1,
            textAlign: "center",
            minWidth: { xs: "110px", sm: "auto" },
            py: 1.5,
            cursor: "pointer",
            borderBottom:
              index === activeIndex
                ? `3px solid ${colors.primary[400]}`
                : "3px solid transparent",
            transition: "border-color 0.2s ease, background-color 0.2s ease",
            "&:hover": {
              bgcolor: "rgba(114,78,65,0.05)",
            },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "13px", sm: "16px" },
              whiteSpace: "nowrap",
              fontWeight: index === activeIndex ? 700 : 400,
              color:
                index === activeIndex
                  ? colors.primary[400]
                  : colors.primary[700],
              transition: "color 0.2s ease",
            }}
          >
            {tab}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
